export const TimeIcon = ({ className = "w-6 h-6", color = "currentColor" }) => (
  <svg 
    className={className} 
    fill="none" 
    stroke={color} 
   viewBox="0 0 20 20"
  >
    <path 
    d="M10 2.5C5.85938 2.5 2.5 5.85938 2.5 10C2.5 14.1406 5.85938 17.5 10 17.5C14.1406 17.5 17.5 14.1406 17.5 10C17.5 5.85938 14.1406 2.5 10 2.5Z" 
    stroke="#FF8D28" 
    stroke-width="1.5" 
    stroke-miterlimit="10"
    />
<path 
d="M10 5V10.625H13.75" 
stroke="#FF8D28" 
stroke-width="1.5" 
stroke-linecap="round" 
stroke-linejoin="round"
/>

  </svg>
);

